import { render } from "./componentScanDoc.vue?vue&type=template&id=aa7c49a2"
import script from "./componentScanDoc.vue?vue&type=script&lang=js"
export * from "./componentScanDoc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__